var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"868aa31d2b47dd3ae9399a7c0835b1f04ca0d3ce"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["help-center@klaviyo-1"]={id:"868aa31d2b47dd3ae9399a7c0835b1f04ca0d3ce"};
      